import angular from 'angular'

import { over } from 'lodash-es'

import envRaw from '../utils/env-raw'
import setCss from '../utils/set-css'
import extractRawElm from '../utils/extract-raw-elm'

import Template from './gallery-preview.component.ejs'
import TextPreview from './gallery-preview.text-preview.ejs'
import ThumbPreview from './gallery-preview.thumb-preview.ejs'

import VIDEO_ICON from '../../img/video-marker.svg'
import UNKNOWN_ICON from '../../img/unknown-marker.svg'

angular
  .module('ggs.gallery-preview')
  .component('ggsGalleryPreview', {
    template: Template({
      LE: envRaw.liveEditMode,
      textPreview: TextPreview({
        LE: envRaw.liveEditMode,
        UNKNOWN_ICON
      }),
      thumbPreview: ThumbPreview({
        LE: envRaw.liveEditMode,
        VIDEO_ICON,
        UNKNOWN_ICON
      })
    }),
    controller: GalleryPreviewComponent,
    bindings: {
      ggsPost: '<',
      ggsProperties: '<',
      ggsPostVoteEmitter: '<',
      ggsPreviewInitHandler: '<',
      ggsPreviewReadyHandler: '<',
      ggsPreviewDestroyHandler: '<',
      ggsPreviewDoneHandler: '<',
      ggsPreviewFailHandler: '<',
      ggsPreviewDenyHandler: '<',
      ggsPreviewSelectHandler: '<'
    }
  })

const QS_USER = '.ggs-gallery-preview__user'
const QS_HEADER = '.ggs-gallery-preview__header'
const QS_FOOTER = '.ggs-gallery-preview__footer'
const QS_SHOWCASE = '.ggs-gallery-preview__showcase'

const USER_TINY_ATTR = 'ggs-gallery-user-tiny'
const USER_TINY_MAX_WIDTH = 170

const USER_EMPTY_ATTR = 'ggs-gallery-user-empty'
const USER_EMPTY_MAX_WIDTH = 70

const SHOWCASE_HOR_TINY_ATTR = 'ggs-gallery-preview-hor-tiny'
const SHOWCASE_HOR_TINY_MAX_WIDTH = 170

const SHOWCASE_VER_TINY_ATTR = 'ggs-gallery-preview-ver-tiny'
const SHOWCASE_VER_TINY_RULES = [
  { from: -Infinity, to: 90 },
  { from: 90, to: 110 },
  { from: 110, to: 130 },
  { from: 130, to: 150 },
  { from: 150, to: 170 },
  { from: 170, to: 190 }
]

const HIDDEN_CLASS = 'ggs-gallery-preview_hidden'
const FAILED_CLASS = 'ggs-gallery-preview_failed'
const DENIED_CLASS = 'ggs-gallery-preview_denied'

function GalleryPreviewComponent(
  domh,
  $scope,
  locale,
  $element) {

  const $ctrl = $scope.$ctrl = this

  const elm = extractRawElm($element)
  elm.classList.add(HIDDEN_CLASS)

  let isDestroyed = false
  let isStateEmitted = false

  $ctrl.getCreatedAtFull = () => {
    return locale.longDateTime($ctrl.ggsPost.external_created_at)
  }

  $ctrl.getCreatedAtShort = () => {
    return locale.shortDateTime($ctrl.ggsPost.external_created_at)
  }

  $ctrl.$onInit = () => {
    return $ctrl.ggsPreviewInitHandler($ctrl.ggsPost)
  }

  $ctrl.$onDestroy = () => {
    isDestroyed = true
    return $ctrl.ggsPreviewDestroyHandler($ctrl.ggsPost)
  }

  $ctrl.selectPostHandler = () => {
    if (isDestroyed) return

    return $ctrl.ggsPreviewSelectHandler($ctrl.ggsPost)
  }

  $ctrl.contentDoneCallback = (calcContentWidth, calcContentHeight, applyShowcaseSize) => {
    if (isDestroyed) return
    if (isStateEmitted) return

    const reg = {
      elm,
      post: $ctrl.ggsPost,
      prepareToDisplay,
      reportPreviewDone,
      reportPreviewFail,
      reportPreviewDeny,
      calcContentWidth,
      calcContentHeight,
      applyShowcaseSize: over(
        applyPreviewSize,
        applyShowcaseSize)
    }

    return $ctrl.ggsPreviewReadyHandler($ctrl.ggsPost, reg)
  }

  $ctrl.contentFailCallback = () => {
    if (isDestroyed) return
    if (isStateEmitted) return

    isStateEmitted = true
    elm.classList.add(FAILED_CLASS)
    return $ctrl.ggsPreviewFailHandler($ctrl.ggsPost)
  }

  // display flow

  function prepareToDisplay() {
    if (isDestroyed) return

    elm.classList.remove(HIDDEN_CLASS)
  }

  function reportPreviewDone() {
    if (isDestroyed) return
    if (isStateEmitted) return

    isStateEmitted = true
    return $ctrl.ggsPreviewDoneHandler($ctrl.ggsPost)
  }

  function reportPreviewFail() {
    if (isDestroyed) return
    if (isStateEmitted) return

    isStateEmitted = true
    elm.classList.add(FAILED_CLASS)
    return $ctrl.ggsPreviewFailHandler($ctrl.ggsPost)
  }

  function reportPreviewDeny() {
    if (isDestroyed) return
    if (isStateEmitted) return

    isStateEmitted = true
    elm.classList.add(DENIED_CLASS)
    return $ctrl.ggsPreviewDenyHandler($ctrl.ggsPost)
  }

  // applyPreviewSize

  function applyPreviewSize(psmSize) {
    const userElm = domh.find.notStrict(elm, QS_USER)
    const headerElm = domh.find.notStrict(elm, QS_HEADER)
    const footerElm = domh.find.notStrict(elm, QS_FOOTER)
    const showcaseElm = domh.find(elm, QS_SHOWCASE)

    if (headerElm) {
      setCss(headerElm, 'width', psmSize.showcaseWidth)
    }

    if (footerElm) {
      setCss(footerElm, 'width', psmSize.showcaseWidth)
    }

    if (userElm) {
      psmSize.showcaseWidth < USER_TINY_MAX_WIDTH
        ? userElm.setAttribute(USER_TINY_ATTR, true)
        : userElm.removeAttribute(USER_TINY_ATTR)

      psmSize.showcaseWidth < USER_EMPTY_MAX_WIDTH
        ? userElm.setAttribute(USER_EMPTY_ATTR, true)
        : userElm.removeAttribute(USER_EMPTY_ATTR)
    }

    setCss(showcaseElm, 'width', psmSize.showcaseWidth)
    setCss(showcaseElm, 'height', psmSize.showcaseHeight)

    psmSize.showcaseWidth < SHOWCASE_HOR_TINY_MAX_WIDTH
      ? showcaseElm.setAttribute(SHOWCASE_HOR_TINY_ATTR, true)
      : showcaseElm.removeAttribute(SHOWCASE_HOR_TINY_ATTR)

    showcaseElm.removeAttribute(SHOWCASE_VER_TINY_ATTR)
    for (let index = SHOWCASE_VER_TINY_RULES.length - 1; index !== -1; index--) {
      const verRule = SHOWCASE_VER_TINY_RULES[index]
      if ((psmSize.showcaseHeight > verRule.from) && (psmSize.showcaseHeight <= verRule.to)) {
        showcaseElm.setAttribute(SHOWCASE_VER_TINY_ATTR, verRule.to)
        break
      }
    }
  }
}
